var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('v-card',{attrs:{"flat":""}},[_c('Table',{attrs:{"items":_vm.items}}),_c('Breakdown',{attrs:{"items":_vm.data.breakdown}}),_c('Breakdown',{attrs:{"items":_vm.data.typebreakdown}}),_c('Table',{attrs:{"items":_vm.detail_items}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }